export function formatWidgetClassName(str: string): string {
  return (
    str
      .split("-")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join("") + "Widget"
  );
}
